import React, { useEffect } from "react";

// import 'sweetalert2/src/sweetalert2.scss'

//import Scss
import "react-step-progress/dist/index.css";
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";

// Import Firebase Configuration file
import { useDispatch } from "react-redux";
import { PrimaryLogo } from "./Components/Logo/PrimaryLogo";
import SignAgreementModal from "./Components/modals/SignAgreementModal/SignAgreementModal";
import { DASHBOARD_USER_ROLES } from "./constants";
import { AgreementType } from "./modules/agreements/types";
import { useAgreements, useCurrentUser } from "./slices/auth/hooks";
import { setAgreements } from "./slices/auth/reducer";
import { getSignedUserAgreements } from "./slices/thunks";


function App() {
  const [initialized, setInitialized] = React.useState(true);
  const [signAgreementModalOpen, setSignAgreementModalOpen] = React.useState(false);
  const [signAgremeentType, setSignAgreementType] = React.useState("producer");
  const dispatch = useDispatch();

  const currentUser = useCurrentUser();
  const agreements = useAgreements();


  useEffect(() => {
    if (!currentUser) return;

    // If current user is GA or Broker, fetch agreements.
    if (!currentUser.onboardingCompleted) {
      return;
    }

    const handleUserAgreementsActions = async () => {
      const isGAOrBroker =
        [DASHBOARD_USER_ROLES.GA, DASHBOARD_USER_ROLES.BROKER].includes(currentUser.role);
      const isEmployer = currentUser.role === DASHBOARD_USER_ROLES.EMPLOYER;

      if (isGAOrBroker) {

        // Fetch all agreements
        const response = await dispatch(getSignedUserAgreements());

        if (response.error) {
          return;
        }

        const agreements = response.data;

        dispatch(setAgreements(agreements));

        // Check if signed agreements include Producer agreement.
        // If not, make user sign it.
        const producerAgreement = agreements.find(
          (agreement) => agreement.agreementType === AgreementType.Producer
        );

        if (!producerAgreement) {
          setSignAgreementModalOpen(true);
          setSignAgreementType("producer");

          return;
        }
        return agreements;
      }
      if (isEmployer) {

        // Fetch all agreements
        const response = await dispatch(getSignedUserAgreements());

        if (response.error) {
          return;
        }

        const agreements = response.data;

        dispatch(setAgreements(agreements));

        // Check if signed agreements include Organization agreement.
        // If not, make user sign it.
        const organizationAgreement = agreements.find(
          (agreement) => agreement.agreementType === AgreementType.Organization
        );

        if (!organizationAgreement) {
          setSignAgreementModalOpen(true);
          setSignAgreementType("organization");

          return;
        }
        return agreements;
      }


    }

    handleUserAgreementsActions();

  }, [currentUser?.id]);


  // if (!initialized) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         height: "100vh",
  //         width: "100vw",
  //         flexDirection: "column",
  //       }}
  //     >
  //       <PrimaryLogo style={{
  //         width: "200px",
  //         height: "auto",
  //         marginBottom: "20px",
  //       }} />

  //       <span>Loading..</span>
  //     </div>
  //   );
  // }

  return (
    <React.Fragment>
      <Route />

      {signAgreementModalOpen && (
        <SignAgreementModal
          type={signAgremeentType}
          onAgreementSigned={() => {
            setSignAgreementModalOpen(false);
          }}
          open={signAgreementModalOpen} setOpen={setSignAgreementModalOpen} />
      )}

    </React.Fragment>
  );
}

export default App;
